import React from 'react';
import _ from 'lodash';
import NumberUtils from '../../utils/NumberUtils';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import StringConstant from '../../constants/StringConstants';
import DateUtils from '../../utils/DateUtils';
import UserManagementStore from '../../stores/UserManagementStore';
import AccountsStore from '../../stores/AccountsStore';
import moment from 'moment';
import { isSavingsPotsActive } from '../../utils/SavingsPotsUtils';

const ACCOUNT_TYPE_CASH_ISA = 'CASH ISA';

class MoveMoneyBL {
  getAccountDisplayNumber(account) {
    if (account.type === 'credit_card') {
      let creditcardNumber = _.replace(
        account.number,
        '************',
        'xxxxxxxxxxxx'
      );
      creditcardNumber = _.split(creditcardNumber, '-');
      const creditcard = NumberUtils.formatCreditCard(creditcardNumber[0]);
      return ` ${creditcard}`;
    } else {
      const accountNumber = _.split(account.number, '-');
      const sortcode = NumberUtils.formatSortCode(accountNumber[0]);
      return (
        <div>
          <span>
            <span className="u-visually-hidden off-screen">
              Account Sort Code
            </span>
            {`${sortcode} | `}
          </span>
          <span>
            <span className="u-visually-hidden off-screen">Account number</span>
            {accountNumber[1]}
          </span>
        </div>
      );
    }
  }

  currentAmount(account, withCurrency = true) {
    let currAmount;
    let curAmount = 0;
    if (account !== undefined) {
      _.map(account.balances, (balance) => {
        switch (balance.type) {
          case StringConstant.current:
            currAmount = balance.amount;
            curAmount = _.split(
              NumberUtils.appendCurrency('{}', currAmount),
              '.'
            );
        }
      });
      return withCurrency ? `${curAmount[0]}.${curAmount[1]}` : currAmount;
    }
    return currAmount;
  }

  availableAmount(account, withCurrency = true) {
    let availlAmount;
    let avlAmount = 0;
    if (account !== undefined) {
      _.map(account.balances, (balance) => {
        switch (balance.type) {
          case StringConstant.available:
            availlAmount = balance.amount;
            avlAmount = _.split(
              NumberUtils.appendCurrency('{}', availlAmount),
              '.'
            );
        }
      });
      return withCurrency ? `${avlAmount[0]}.${avlAmount[1]}` : availlAmount;
    }
    return availlAmount;
  }

  clearedAmount(account, withCurrency = true) {
    let clearedAmount;
    let clrAmount = 0;
    if (account) {
      _.map(account.balances, (balance) => {
        if (balance.type === StringConstant.cleared) {
          clearedAmount = balance.amount;
          clrAmount = _.split(
            NumberUtils.appendCurrency('{}', clearedAmount),
            '.'
          );
        }
      });
      return withCurrency ? `${clrAmount[0]}.${clrAmount[1]}` : clearedAmount;
    }
    return clearedAmount;
  }

  availableOverdraftAmount(account, withCurrency = true) {
    let availableOverdraftAmount;
    let avlOverdraftAmount = 0;
    if (account) {
      _.map(account.balances, (balance) => {
        if (balance.type === StringConstant.availableOverdraft) {
          availableOverdraftAmount = balance.amount;
          avlOverdraftAmount = _.split(
            NumberUtils.appendCurrency('{}', availableOverdraftAmount),
            '.'
          );
        }
      });
      return withCurrency
        ? `${avlOverdraftAmount[0]}.${avlOverdraftAmount[1]}`
        : availableOverdraftAmount;
    }
    return availableOverdraftAmount;
  }
  // Saving Account Methods
  isSavingAccount(account) {
    return (
      account.type === StringConstant.savings &&
      account.product.name !== ACCOUNT_TYPE_CASH_ISA
    );
  }

  // Not used any where -can remove
  /* isSavingTotalClicked(account) {
        return true; // TODO
    }*/

  shouldRenderAsPaymentCard(account) {
    return (
      account.type !== StringConstant.savings ||
      !isSavingsPotsActive() ||
      (account.type === StringConstant.savings &&
        MoveMoneyStore.checkPotEmpty(account.id)) ||
      (account.type === StringConstant.savings &&
        account.product.name === ACCOUNT_TYPE_CASH_ISA)
    );
  }

  getAccountNickname(account) {
    return account.acctNickname ? account.acctNickname : '';
  }

  getPayeeDisplayName(payee) {
    return payee.display_name
      ? payee.display_name
      : payee.to_account.name
      ? payee.to_account.name
      : '';
  }

  getPayeeDisplayNumber(payee) {
    if (payee.to_account !== undefined) {
      const accountNumber = payee.to_account.account_number;
      const sortcode = NumberUtils.formatSortCode(payee.to_account.sort_code);
      return `${sortcode} | ${accountNumber}`;
    }
  }

  shouldShowPayee(fromSelectedAccount, toSelectedAccount, selectedPayee) {
    // return (!_.isEmpty(fromSelectedAccount) && fromSelectedAccount.actionsAvailable['/account/payments/uk/default/out'] && _.isEmpty(toSelectedAccount) && _.isEmpty(selectedPayee));
    // changed code for ben creation - payee link should be displayed always
    let capableAccForBenCreation =
      AccountsStore.getDefaultAccountForBeneficiaryCreation();
    if (_.isEmpty(fromSelectedAccount)) {
      return (
        capableAccForBenCreation !== undefined &&
        _.isEmpty(toSelectedAccount) &&
        _.isEmpty(selectedPayee)
      );
    } else {
      return (
        fromSelectedAccount.actionsAvailable[
          '/account/payments/uk/default/out'
        ] &&
        _.isEmpty(toSelectedAccount) &&
        _.isEmpty(selectedPayee)
      );
    }
  }

  isAccountEligibleForPayment(selectedAccount) {
    return selectedAccount.actionsAvailable['/account/payments/uk/default/out'];
  }

  isAccountSame(selectedAccount, toSelectedAccount) {
    if (!_.isEmpty(toSelectedAccount)) {
      // return selectedAccount.id === toSelectedAccount.id;

      if (this.isSavingAccount(selectedAccount)) {
        if (
          selectedAccount.id === toSelectedAccount.id &&
          _.isEmpty(MoveMoneyStore.getSelectedFromPot())
        ) {
          return true; // Clear T0 list if available balance is selected under FROM
          // MoveMoneyStore.getSelectedFromPot().id comes as undefined for this particular case
        }
        if (
          selectedAccount.id !== toSelectedAccount.id &&
          !_.isEmpty(MoveMoneyStore.getSelectedFromPot())
        ) {
          return true; // User can not transfer from pot of account A to Pot of account B - So clear the to selection
        }
        return (
          selectedAccount.id === toSelectedAccount.id &&
          !_.isEmpty(MoveMoneyStore.getSelectedFromPot()) &&
          !_.isEmpty(MoveMoneyStore.getSelectedToPot()) &&
          MoveMoneyStore.getSelectedFromPot().id ===
            MoveMoneyStore.getSelectedToPot().id
        );
      } else {
        return selectedAccount.id === toSelectedAccount.id;
        // Need to change acording to state once saving components refactored
        // TODO: CHeck below conditions
        // if (MoveMoneyStore.isSavingTotClicked()) {
        //     return selectedAccount.id === toSelectedAccount.id;
        // } else {
        //     return MoveMoneyStore.getSelectedPotData().id === MoveMoneyStore.getSelectedToPotData().id;
        // }
      }
    } else {
      return false;
    }
  }

  isRepeatePaymentValid(payee, account) {
    if (payee.hasOwnProperty('biller_id')) {
      // If payee is biller
      return false;
    }
    return account.actionsAvailable['/account/mandates/so/write'];
  }

  getToAccountList(toAccounts, selectedFromAccount) {
    const accounts = _.cloneDeep(toAccounts);
    if (
      !this.isSavingAccount(selectedFromAccount) ||
      _.isEmpty(MoveMoneyStore.getSelectedFromPot())
    ) {
      return _.remove(
        accounts,
        (account) => account.id !== selectedFromAccount.id
      );
    }
    return accounts;
  }
  // function which returns object which is used for showing and hiding fields in payment form
  // Total pot click conditions still under progress
  formFieldsVisible(fromSelectedAccount, toSelectedAccount, selectedPayee) {
    const fieldOptions = {
      isFormVisible: false,
      isReference: false,
      referenceData: '',
      isTransfer: true,
      isNotEditable: false,
    };
    if (
      MoveMoneyStore.isOneOffPayment() &&
      !MoveMoneyStore.getOneOffPayment().isMonthly
    ) {
      fieldOptions.isTransfer = true;
      fieldOptions.isFormVisible = false;
      fieldOptions.isReference = false;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
    } else if (toSelectedAccount.type === 'credit_card') {
      fieldOptions.isTransfer = true;
      fieldOptions.isFormVisible = true;
      fieldOptions.isReference = false;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
    } else if (fromSelectedAccount.type !== StringConstant.savings) {
      // current account selected in from List
      fieldOptions.isFormVisible = true;
      fieldOptions.isTransfer = true;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
      if (!_.isEmpty(selectedPayee)) {
        // payee selected in to List
        fieldOptions.isReference = true;
        fieldOptions.referenceData = selectedPayee.reference;
        fieldOptions.isTransfer = false;
        if (selectedPayee.hasOwnProperty('biller_id')) {
          fieldOptions.isNotEditable = true;
        }
      } else if (
        !_.isEmpty(
          MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id)
        ) &&
        MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id).name !==
          'Not in Pot'
      ) {
        // Pot selected in To List except Not in pot
        fieldOptions.isReference = false;
      } else {
        fieldOptions.isReference = true;
      }
    } else if (
      !_.isEmpty(
        MoveMoneyStore.getSelectedPotOfFromAccount(fromSelectedAccount.id)
      ) &&
      MoveMoneyStore.getSelectedPotOfFromAccount(fromSelectedAccount.id)
        .name !== 'Not in Pot'
    ) {
      // Pot selected in From List except Not in pot
      fieldOptions.isTransfer = true;
      fieldOptions.isFormVisible = false;
      fieldOptions.isReference = false;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
    } else if (
      MoveMoneyStore.getSelectedPotOfFromAccount(fromSelectedAccount.id)
        .name === 'Not in Pot'
    ) {
      // Not in Pot Selected in From List
      fieldOptions.isTransfer = true;
      fieldOptions.isFormVisible = false;
      fieldOptions.isReference = true;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
      if (
        !_.isEmpty(
          MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id)
        ) &&
        MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id).name !==
          'Not in Pot'
      ) {
        // Pot selected in To list except not in pot
        fieldOptions.isReference = false;
      }
    } else if (
      !_.isEmpty(MoveMoneyStore.getSelectedAccount()) &&
      MoveMoneyStore.getSelectedAccount().id === fromSelectedAccount.id &&
      _.isEmpty(MoveMoneyStore.getSelectedFromPot()) &&
      MoveMoneyStore.getSelectedAccount().type === 'savings'
    ) {
      fieldOptions.isTransfer = true;
      fieldOptions.isFormVisible = false;
      fieldOptions.isReference = true;
      fieldOptions.referenceData = '';
      fieldOptions.isNotEditable = false;
      if (
        !_.isEmpty(
          MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id)
        ) &&
        MoveMoneyStore.getSelectedPotOfToAccount(toSelectedAccount.id).name !==
          'Not in Pot'
      ) {
        // Pot selected in To list except not in pot
        fieldOptions.isReference = false;
      }
    }
    if (!_.isEmpty(selectedPayee)) {
      fieldOptions.isTransfer = false;
      fieldOptions.referenceData = selectedPayee.reference;
      if (selectedPayee.hasOwnProperty('biller_id')) {
        fieldOptions.isNotEditable = true;
      }
    }

    if (UserManagementStore.isNominatedUser()) {
      fieldOptions.isFormVisible = false;
    }
    return fieldOptions;
  }
  // Conditions to make to list saving account pots disabled
  toPotDisableConditions(dataId, potData, fromSelectedId) {
    if (!_.isEmpty(MoveMoneyStore.getSelectedFromPot())) {
      return (
        (dataId !== MoveMoneyStore.getSelectedFromAccount().id &&
          potData.name !== 'Not in Pot') ||
        fromSelectedId === potData.id
      );
    } else {
      return false;
    }
  }
  getRepeatPaymentDay(inputDate) {
    const dateDifference =
      DateUtils.comapareFromCurrentDateSlashFormat(inputDate);
    if (dateDifference === 0) {
      return StringConstant.Today;
    } else if (dateDifference === 1) {
      return StringConstant.Tomorrow;
    } else {
      return null;
    }
  }
  showMoreFocusPrevElement(event, callback) {
    if (event.which === 13 || event.keyCode === 13) {
      const parent = event.target.parentElement;
      if (typeof callback === 'function') {
        callback();
      }
      this.prev = parent.previousSibling;
      if (this.prev && this.prev.tagName === 'LI') {
        setTimeout(() => {
          this.getSiblingDom();
        }, 400);
      }
      event.preventDefault();
    }
  }
  getSiblingDom() {
    this.prev.nextSibling.focus();
  }
  getDateModified(date, dateDifference) {
    let whenDate = DateUtils.getMomentFromDateString(date);
    whenDate = moment(whenDate).format('D MMMM YYYY');
    //  const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(this.props.repeatData.futureDate);
    if (dateDifference === 0) {
      whenDate = `${whenDate} (Today)`;
    } else if (dateDifference === 1) {
      whenDate = `${whenDate} (Tomorrow)`;
    }
    return whenDate;
  }
  validateReferenceKey(fieldData) {
    if (
      fieldData.hasOwnProperty('reference') &&
      (fieldData.reference === undefined ||
        fieldData.reference === null ||
        fieldData.reference.trim().length === 0)
    ) {
      delete fieldData.reference;
      return fieldData;
    } else {
      return fieldData;
    }
  }
  shouldShowArrangedOverdraft(account) {
    return account.balances.some(
      (balance) => balance.type === StringConstant.availableOverdraft
    );
  }
}

export default new MoveMoneyBL();
